(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "../../node_modules/object-assign/index.js":
/*!*********************************************************************!*\
  !*** /Users/santi/code/example/node_modules/object-assign/index.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "../../node_modules/prop-types/checkPropTypes.js":
/*!***************************************************************************!*\
  !*** /Users/santi/code/example/node_modules/prop-types/checkPropTypes.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (true) {
  var ReactPropTypesSecret = __webpack_require__(/*! ./lib/ReactPropTypesSecret */ "../../node_modules/prop-types/lib/ReactPropTypesSecret.js");
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (true) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (true) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),

/***/ "../../node_modules/prop-types/lib/ReactPropTypesSecret.js":
/*!*************************************************************************************!*\
  !*** /Users/santi/code/example/node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ "../../node_modules/react/cjs/react.development.js":
/*!*****************************************************************************!*\
  !*** /Users/santi/code/example/node_modules/react/cjs/react.development.js ***!
  \*****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (true) {
  (function() {
'use strict';

var _assign = __webpack_require__(/*! object-assign */ "../../node_modules/object-assign/index.js");
var checkPropTypes = __webpack_require__(/*! prop-types/checkPropTypes */ "../../node_modules/prop-types/checkPropTypes.js");

var ReactVersion = '16.14.0';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

/**
 * Keeps track of the current dispatcher.
 */
var ReactCurrentDispatcher = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

/**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */
var ReactCurrentBatchConfig = {
  suspense: null
};

/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
function describeComponentFrame (name, source, ownerName) {
  var sourceInfo = '';

  if (source) {
    var path = source.fileName;
    var fileName = path.replace(BEFORE_SLASH_RE, '');

    {
      // In DEV, include code for a common special case:
      // prefer "folder/index.js" instead of just "index.js".
      if (/^index\./.test(fileName)) {
        var match = path.match(BEFORE_SLASH_RE);

        if (match) {
          var pathBeforeSlash = match[1];

          if (pathBeforeSlash) {
            var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, '');
            fileName = folderName + '/' + fileName;
          }
        }
      }
    }

    sourceInfo = ' (at ' + fileName + ':' + source.lineNumber + ')';
  } else if (ownerName) {
    sourceInfo = ' (created by ' + ownerName + ')';
  }

  return '\n    in ' + (name || 'Unknown') + sourceInfo;
}

var Resolved = 1;
function refineResolvedLazyComponent(lazyComponent) {
  return lazyComponent._status === Resolved ? lazyComponent._result : null;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case REACT_FRAGMENT_TYPE:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return "Profiler";

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        return 'Context.Consumer';

      case REACT_PROVIDER_TYPE:
        return 'Context.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type.render);

      case REACT_LAZY_TYPE:
        {
          var thenable = type;
          var resolvedThenable = refineResolvedLazyComponent(thenable);

          if (resolvedThenable) {
            return getComponentName(resolvedThenable);
          }

          break;
        }
    }
  }

  return null;
}

var ReactDebugCurrentFrame = {};
var currentlyValidatingElement = null;
function setCurrentlyValidatingElement(element) {
  {
    currentlyValidatingElement = element;
  }
}

{
  // Stack implementation injected by the current renderer.
  ReactDebugCurrentFrame.getCurrentStack = null;

  ReactDebugCurrentFrame.getStackAddendum = function () {
    var stack = ''; // Add an extra top frame while an element is being validated

    if (currentlyValidatingElement) {
      var name = getComponentName(currentlyValidatingElement.type);
      var owner = currentlyValidatingElement._owner;
      stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
    } // Delegate to the injected renderer-specific implementation


    var impl = ReactDebugCurrentFrame.getCurrentStack;

    if (impl) {
      stack += impl() || '';
    }

    return stack;
  };
}

/**
 * Used by act() to track whether you're inside an act() scope.
 */
var IsSomeRendererActing = {
  current: false
};

var ReactSharedInternals = {
  ReactCurrentDispatcher: ReactCurrentDispatcher,
  ReactCurrentBatchConfig: ReactCurrentBatchConfig,
  ReactCurrentOwner: ReactCurrentOwner,
  IsSomeRendererActing: IsSomeRendererActing,
  // Used by renderers to avoid bundling object-assign twice in UMD bundles:
  assign: _assign
};

{
  _assign(ReactSharedInternals, {
    // These should not be included in production.
    ReactDebugCurrentFrame: ReactDebugCurrentFrame,
    // Shim for React DOM 16.0.0 which still destructured (but not used) this.
    // TODO: remove in React 17.0.
    ReactComponentTreeHook: {}
  });
}

// by calls to these methods by a Babel plugin.
//
// In PROD (or in packages without access to React internals),
// they are left as they are instead.

function warn(format) {
  {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    printWarning('warn', format, args);
  }
}
function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var hasExistingStack = args.length > 0 && typeof args[args.length - 1] === 'string' && args[args.length - 1].indexOf('\n    in') === 0;

    if (!hasExistingStack) {
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      var stack = ReactDebugCurrentFrame.getStackAddendum();

      if (stack !== '') {
        format += '%s';
        args = args.concat([stack]);
      }
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      throw new Error(message);
    } catch (x) {}
  }
}

var didWarnStateUpdateForUnmountedComponent = {};

function warnNoop(publicInstance, callerName) {
  {
    var _constructor = publicInstance.constructor;
    var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
    var warningKey = componentName + "." + callerName;

    if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
      return;
    }

    error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);

    didWarnStateUpdateForUnmountedComponent[warningKey] = true;
  }
}
/**
 * This is the abstract API for an update queue.
 */


var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance, callback, callerName) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState, callback, callerName) {
    warnNoop(publicInstance, 'setState');
  }
};

var emptyObject = {};

{
  Object.freeze(emptyObject);
}
/**
 * Base class helpers for the updating state of a component.
 */


function Component(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
  // renderer.

  this.updater = updater || ReactNoopUpdateQueue;
}

Component.prototype.isReactComponent = {};
/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */

Component.prototype.setState = function (partialState, callback) {
  if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
    {
      throw Error( "setState(...): takes an object of state variables to update or a function which returns an object of state variables." );
    }
  }

  this.updater.enqueueSetState(this, partialState, callback, 'setState');
};
/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */


Component.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
};
/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */


{
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };

  var defineDeprecationWarning = function (methodName, info) {
    Object.defineProperty(Component.prototype, methodName, {
      get: function () {
        warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);

        return undefined;
      }
    });
  };

  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

function ComponentDummy() {}

ComponentDummy.prototype = Component.prototype;
/**
 * Convenience component with default shallow equality check for sCU.
 */

function PureComponent(props, context, updater) {
  this.props = props;
  this.context = context; // If a component has string refs, we will assign a different object later.

  this.refs = emptyObject;
  this.updater = updater || ReactNoopUpdateQueue;
}

var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.

_assign(pureComponentPrototype, Component.prototype);

pureComponentPrototype.isPureReactComponent = true;

// an immutable object with a single mutable value
function createRef() {
  var refObject = {
    current: null
  };

  {
    Object.seal(refObject);
  }

  return refObject;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
      }
    }
  };

  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName);
      }
    }
  };

  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

function warnIfStringRefCannotBeAutoConverted(config) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://fb.me/react-strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */

function createElement(type, config, children) {
  var propName; // Reserved names are extracted

  var props = {};
  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;

      {
        warnIfStringRefCannotBeAutoConverted(config);
      }
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }

    props.children = childArray;
  } // Resolve default props


  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;

    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }

  {
    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }
  }

  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
}
function cloneAndReplaceKey(oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
  return newElement;
}
/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */

function cloneElement(element, config, children) {
  if (!!(element === null || element === undefined)) {
    {
      throw Error( "React.cloneElement(...): The argument must be a React element, but you passed " + element + "." );
    }
  }

  var propName; // Original props are copied

  var props = _assign({}, element.props); // Reserved names are extracted


  var key = element.key;
  var ref = element.ref; // Self is preserved since the owner is preserved.

  var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.

  var source = element._source; // Owner will be preserved, unless ref is overridden

  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    } // Remaining properties override existing props


    var defaultProps;

    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }

    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  } // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.


  var childrenLength = arguments.length - 2;

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }

    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}

var SEPARATOR = '.';
var SUBSEPARATOR = ':';
/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });
  return '$' + escapedString;
}
/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */


var didWarnAboutMaps = false;
var userProvidedKeyEscapeRegex = /\/+/g;

function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

var POOL_SIZE = 10;
var traverseContextPool = [];

function getPooledTraverseContext(mapResult, keyPrefix, mapFunction, mapContext) {
  if (traverseContextPool.length) {
    var traverseContext = traverseContextPool.pop();
    traverseContext.result = mapResult;
    traverseContext.keyPrefix = keyPrefix;
    traverseContext.func = mapFunction;
    traverseContext.context = mapContext;
    traverseContext.count = 0;
    return traverseContext;
  } else {
    return {
      result: mapResult,
      keyPrefix: keyPrefix,
      func: mapFunction,
      context: mapContext,
      count: 0
    };
  }
}

function releaseTraverseContext(traverseContext) {
  traverseContext.result = null;
  traverseContext.keyPrefix = null;
  traverseContext.func = null;
  traverseContext.context = null;
  traverseContext.count = 0;

  if (traverseContextPool.length < POOL_SIZE) {
    traverseContextPool.push(traverseContext);
  }
}
/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */


function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  var invokeCallback = false;

  if (children === null) {
    invokeCallback = true;
  } else {
    switch (type) {
      case 'string':
      case 'number':
        invokeCallback = true;
        break;

      case 'object':
        switch (children.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            invokeCallback = true;
        }

    }
  }

  if (invokeCallback) {
    callback(traverseContext, children, // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.

  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);

    if (typeof iteratorFn === 'function') {

      {
        // Warn about using Maps as children
        if (iteratorFn === children.entries) {
          if (!didWarnAboutMaps) {
            warn('Using Maps as children is deprecated and will be removed in ' + 'a future major release. Consider converting children to ' + 'an array of keyed ReactElements instead.');
          }

          didWarnAboutMaps = true;
        }
      }

      var iterator = iteratorFn.call(children);
      var step;
      var ii = 0;

      while (!(step = iterator.next()).done) {
        child = step.value;
        nextName = nextNamePrefix + getComponentKey(child, ii++);
        subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
      }
    } else if (type === 'object') {
      var addendum = '';

      {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead.' + ReactDebugCurrentFrame.getStackAddendum();
      }

      var childrenString = '' + children;

      {
        {
          throw Error( "Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + ")." + addendum );
        }
      }
    }
  }

  return subtreeCount;
}
/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */


function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}
/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */


function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (typeof component === 'object' && component !== null && component.key != null) {
    // Explicit key
    return escape(component.key);
  } // Implicit key determined by the index in the set


  return index.toString(36);
}

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;
  func.call(context, child, bookKeeping.count++);
}
/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */


function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }

  var traverseContext = getPooledTraverseContext(null, null, forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  releaseTraverseContext(traverseContext);
}

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;
  var mappedChild = func.call(context, child, bookKeeping.count++);

  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, function (c) {
      return c;
    });
  } else if (mappedChild != null) {
    if (isValidElement(mappedChild)) {
      mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }

    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';

  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }

  var traverseContext = getPooledTraverseContext(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  releaseTraverseContext(traverseContext);
}
/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */


function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }

  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}
/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */


function countChildren(children) {
  return traverseAllChildren(children, function () {
    return null;
  }, null);
}
/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */


function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, function (child) {
    return child;
  });
  return result;
}
/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */


function onlyChild(children) {
  if (!isValidElement(children)) {
    {
      throw Error( "React.Children.only expected to receive a single React element child." );
    }
  }

  return children;
}

function createContext(defaultValue, calculateChangedBits) {
  if (calculateChangedBits === undefined) {
    calculateChangedBits = null;
  } else {
    {
      if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
        error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
      }
    }
  }

  var context = {
    $$typeof: REACT_CONTEXT_TYPE,
    _calculateChangedBits: calculateChangedBits,
    // As a workaround to support multiple concurrent renderers, we categorize
    // some renderers as primary and others as secondary. We only expect
    // there to be two concurrent renderers at most: React Native (primary) and
    // Fabric (secondary); React DOM (primary) and React ART (secondary).
    // Secondary renderers store their context values on separate fields.
    _currentValue: defaultValue,
    _currentValue2: defaultValue,
    // Used to track how many concurrent renderers this context currently
    // supports within in a single renderer. Such as parallel server rendering.
    _threadCount: 0,
    // These are circular
    Provider: null,
    Consumer: null
  };
  context.Provider = {
    $$typeof: REACT_PROVIDER_TYPE,
    _context: context
  };
  var hasWarnedAboutUsingNestedContextConsumers = false;
  var hasWarnedAboutUsingConsumerProvider = false;

  {
    // A separate object, but proxies back to the original context object for
    // backwards compatibility. It has a different $$typeof, so we can properly
    // warn for the incorrect usage of Context as a Consumer.
    var Consumer = {
      $$typeof: REACT_CONTEXT_TYPE,
      _context: context,
      _calculateChangedBits: context._calculateChangedBits
    }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here

    Object.defineProperties(Consumer, {
      Provider: {
        get: function () {
          if (!hasWarnedAboutUsingConsumerProvider) {
            hasWarnedAboutUsingConsumerProvider = true;

            error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
          }

          return context.Provider;
        },
        set: function (_Provider) {
          context.Provider = _Provider;
        }
      },
      _currentValue: {
        get: function () {
          return context._currentValue;
        },
        set: function (_currentValue) {
          context._currentValue = _currentValue;
        }
      },
      _currentValue2: {
        get: function () {
          return context._currentValue2;
        },
        set: function (_currentValue2) {
          context._currentValue2 = _currentValue2;
        }
      },
      _threadCount: {
        get: function () {
          return context._threadCount;
        },
        set: function (_threadCount) {
          context._threadCount = _threadCount;
        }
      },
      Consumer: {
        get: function () {
          if (!hasWarnedAboutUsingNestedContextConsumers) {
            hasWarnedAboutUsingNestedContextConsumers = true;

            error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
          }

          return context.Consumer;
        }
      }
    }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty

    context.Consumer = Consumer;
  }

  {
    context._currentRenderer = null;
    context._currentRenderer2 = null;
  }

  return context;
}

function lazy(ctor) {
  var lazyType = {
    $$typeof: REACT_LAZY_TYPE,
    _ctor: ctor,
    // React uses these fields to store the result.
    _status: -1,
    _result: null
  };

  {
    // In production, this would just set it on the object.
    var defaultProps;
    var propTypes;
    Object.defineProperties(lazyType, {
      defaultProps: {
        configurable: true,
        get: function () {
          return defaultProps;
        },
        set: function (newDefaultProps) {
          error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          defaultProps = newDefaultProps; // Match production behavior more closely:

          Object.defineProperty(lazyType, 'defaultProps', {
            enumerable: true
          });
        }
      },
      propTypes: {
        configurable: true,
        get: function () {
          return propTypes;
        },
        set: function (newPropTypes) {
          error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');

          propTypes = newPropTypes; // Match production behavior more closely:

          Object.defineProperty(lazyType, 'propTypes', {
            enumerable: true
          });
        }
      }
    });
  }

  return lazyType;
}

function forwardRef(render) {
  {
    if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
      error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
    } else if (typeof render !== 'function') {
      error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
    } else {
      if (render.length !== 0 && render.length !== 2) {
        error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
      }
    }

    if (render != null) {
      if (render.defaultProps != null || render.propTypes != null) {
        error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
      }
    }
  }

  return {
    $$typeof: REACT_FORWARD_REF_TYPE,
    render: render
  };
}

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function memo(type, compare) {
  {
    if (!isValidElementType(type)) {
      error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
    }
  }

  return {
    $$typeof: REACT_MEMO_TYPE,
    type: type,
    compare: compare === undefined ? null : compare
  };
}

function resolveDispatcher() {
  var dispatcher = ReactCurrentDispatcher.current;

  if (!(dispatcher !== null)) {
    {
      throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem." );
    }
  }

  return dispatcher;
}

function useContext(Context, unstable_observedBits) {
  var dispatcher = resolveDispatcher();

  {
    if (unstable_observedBits !== undefined) {
      error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://fb.me/rules-of-hooks' : '');
    } // TODO: add a more generic warning for invalid values.


    if (Context._context !== undefined) {
      var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
      // and nobody should be using this in existing code.

      if (realContext.Consumer === Context) {
        error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
      } else if (realContext.Provider === Context) {
        error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
      }
    }
  }

  return dispatcher.useContext(Context, unstable_observedBits);
}
function useState(initialState) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useState(initialState);
}
function useReducer(reducer, initialArg, init) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useReducer(reducer, initialArg, init);
}
function useRef(initialValue) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useRef(initialValue);
}
function useEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useEffect(create, deps);
}
function useLayoutEffect(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useLayoutEffect(create, deps);
}
function useCallback(callback, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useCallback(callback, deps);
}
function useMemo(create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useMemo(create, deps);
}
function useImperativeHandle(ref, create, deps) {
  var dispatcher = resolveDispatcher();
  return dispatcher.useImperativeHandle(ref, create, deps);
}
function useDebugValue(value, formatterFn) {
  {
    var dispatcher = resolveDispatcher();
    return dispatcher.useDebugValue(value, formatterFn);
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}

function getDeclarationErrorAddendum() {
  if (ReactCurrentOwner.current) {
    var name = getComponentName(ReactCurrentOwner.current.type);

    if (name) {
      return '\n\nCheck the render method of `' + name + '`.';
    }
  }

  return '';
}

function getSourceInfoErrorAddendum(source) {
  if (source !== undefined) {
    var fileName = source.fileName.replace(/^.*[\\\/]/, '');
    var lineNumber = source.lineNumber;
    return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
  }

  return '';
}

function getSourceInfoErrorAddendumForProps(elementProps) {
  if (elementProps !== null && elementProps !== undefined) {
    return getSourceInfoErrorAddendum(elementProps.__source);
  }

  return '';
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  var info = getDeclarationErrorAddendum();

  if (!info) {
    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

    if (parentName) {
      info = "\n\nCheck the top-level render call using <" + parentName + ">.";
    }
  }

  return info;
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  if (!element._store || element._store.validated || element.key != null) {
    return;
  }

  element._store.validated = true;
  var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

  if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
    return;
  }

  ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
  // property, it may be the creator of the child that's responsible for
  // assigning it a key.

  var childOwner = '';

  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
    // Give the component that originally created this child.
    childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
  }

  setCurrentlyValidatingElement(element);

  {
    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://fb.me/react-warning-keys for more information.', currentComponentErrorInfo, childOwner);
  }

  setCurrentlyValidatingElement(null);
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  if (typeof node !== 'object') {
    return;
  }

  if (Array.isArray(node)) {
    for (var i = 0; i < node.length; i++) {
      var child = node[i];

      if (isValidElement(child)) {
        validateExplicitKey(child, parentType);
      }
    }
  } else if (isValidElement(node)) {
    // This element was passed in a valid location.
    if (node._store) {
      node._store.validated = true;
    }
  } else if (node) {
    var iteratorFn = getIteratorFn(node);

    if (typeof iteratorFn === 'function') {
      // Entry iterators used to provide implicit keys,
      // but now we print a separate warning for them later.
      if (iteratorFn !== node.entries) {
        var iterator = iteratorFn.call(node);
        var step;

        while (!(step = iterator.next()).done) {
          if (isValidElement(step.value)) {
            validateExplicitKey(step.value, parentType);
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var name = getComponentName(type);
    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      setCurrentlyValidatingElement(element);
      checkPropTypes(propTypes, element.props, 'prop', name, ReactDebugCurrentFrame.getStackAddendum);
      setCurrentlyValidatingElement(null);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true;

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    setCurrentlyValidatingElement(fragment);
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        break;
      }
    }

    if (fragment.ref !== null) {
      error('Invalid attribute `ref` supplied to `React.Fragment`.');
    }

    setCurrentlyValidatingElement(null);
  }
}
function createElementWithValidation(type, props, children) {
  var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
  // succeed and there will likely be errors in render.

  if (!validType) {
    var info = '';

    if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
      info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
    }

    var sourceInfo = getSourceInfoErrorAddendumForProps(props);

    if (sourceInfo) {
      info += sourceInfo;
    } else {
      info += getDeclarationErrorAddendum();
    }

    var typeString;

    if (type === null) {
      typeString = 'null';
    } else if (Array.isArray(type)) {
      typeString = 'array';
    } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
      typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
      info = ' Did you accidentally export a JSX literal instead of a component?';
    } else {
      typeString = typeof type;
    }

    {
      error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }
  }

  var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
  // TODO: Drop this when these are no longer allowed as the type argument.

  if (element == null) {
    return element;
  } // Skip key warning if the type isn't valid since our key validation logic
  // doesn't expect a non-string/function type and can throw confusing errors.
  // We don't want exception behavior to differ between dev and prod.
  // (Rendering will throw with a helpful message and as soon as the type is
  // fixed, the key warnings will appear.)


  if (validType) {
    for (var i = 2; i < arguments.length; i++) {
      validateChildKeys(arguments[i], type);
    }
  }

  if (type === REACT_FRAGMENT_TYPE) {
    validateFragmentProps(element);
  } else {
    validatePropTypes(element);
  }

  return element;
}
var didWarnAboutDeprecatedCreateFactory = false;
function createFactoryWithValidation(type) {
  var validatedFactory = createElementWithValidation.bind(null, type);
  validatedFactory.type = type;

  {
    if (!didWarnAboutDeprecatedCreateFactory) {
      didWarnAboutDeprecatedCreateFactory = true;

      warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
    } // Legacy hook: remove it


    Object.defineProperty(validatedFactory, 'type', {
      enumerable: false,
      get: function () {
        warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');

        Object.defineProperty(this, 'type', {
          value: type
        });
        return type;
      }
    });
  }

  return validatedFactory;
}
function cloneElementWithValidation(element, props, children) {
  var newElement = cloneElement.apply(this, arguments);

  for (var i = 2; i < arguments.length; i++) {
    validateChildKeys(arguments[i], newElement.type);
  }

  validatePropTypes(newElement);
  return newElement;
}

{

  try {
    var frozenObject = Object.freeze({});
    var testMap = new Map([[frozenObject, null]]);
    var testSet = new Set([frozenObject]); // This is necessary for Rollup to not consider these unused.
    // https://github.com/rollup/rollup/issues/1771
    // TODO: we can remove these if Rollup fixes the bug.

    testMap.set(0, 0);
    testSet.add(0);
  } catch (e) {
  }
}

var createElement$1 =  createElementWithValidation ;
var cloneElement$1 =  cloneElementWithValidation ;
var createFactory =  createFactoryWithValidation ;
var Children = {
  map: mapChildren,
  forEach: forEachChildren,
  count: countChildren,
  toArray: toArray,
  only: onlyChild
};

exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
exports.cloneElement = cloneElement$1;
exports.createContext = createContext;
exports.createElement = createElement$1;
exports.createFactory = createFactory;
exports.createRef = createRef;
exports.forwardRef = forwardRef;
exports.isValidElement = isValidElement;
exports.lazy = lazy;
exports.memo = memo;
exports.useCallback = useCallback;
exports.useContext = useContext;
exports.useDebugValue = useDebugValue;
exports.useEffect = useEffect;
exports.useImperativeHandle = useImperativeHandle;
exports.useLayoutEffect = useLayoutEffect;
exports.useMemo = useMemo;
exports.useReducer = useReducer;
exports.useRef = useRef;
exports.useState = useState;
exports.version = ReactVersion;
  })();
}


/***/ }),

/***/ "../../node_modules/react/index.js":
/*!*************************************************************!*\
  !*** /Users/santi/code/example/node_modules/react/index.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react.development.js */ "../../node_modules/react/cjs/react.development.js");
}


/***/ }),

/***/ "../utils/dist/utils.js":
/*!******************************!*\
  !*** ../utils/dist/utils.js ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports, /******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = "./src/index.js");
  /******/
}(
/************************************************************************/
/******/{

  /***/"../../node_modules/babel-runtime/node_modules/regenerator-runtime/runtime-module.js":
  /*!***************************************************************************************************************!*\
    !*** /Users/santi/code/example/node_modules/babel-runtime/node_modules/regenerator-runtime/runtime-module.js ***!
    \***************************************************************************************************************/
  /*! no static exports found */
  /***/function node_modulesBabelRuntimeNode_modulesRegeneratorRuntimeRuntimeModuleJs(module, exports, __webpack_require__) {

    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    // This method of obtaining a reference to the global object needs to be
    // kept identical to the way it is obtained in runtime.js
    var g = function () {
      return this;
    }() || Function("return this")();

    // Use `getOwnPropertyNames` because not all browsers support calling
    // `hasOwnProperty` on the global `self` object in a worker. See #183.
    var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

    // Save the old regeneratorRuntime in case it needs to be restored later.
    var oldRuntime = hadRuntime && g.regeneratorRuntime;

    // Force reevalutation of runtime.js.
    g.regeneratorRuntime = undefined;

    module.exports = __webpack_require__( /*! ./runtime */"../../node_modules/babel-runtime/node_modules/regenerator-runtime/runtime.js");

    if (hadRuntime) {
      // Restore the original runtime.
      g.regeneratorRuntime = oldRuntime;
    } else {
      // Remove the global property added by runtime.js.
      try {
        delete g.regeneratorRuntime;
      } catch (e) {
        g.regeneratorRuntime = undefined;
      }
    }

    /***/
  },

  /***/"../../node_modules/babel-runtime/node_modules/regenerator-runtime/runtime.js":
  /*!********************************************************************************************************!*\
    !*** /Users/santi/code/example/node_modules/babel-runtime/node_modules/regenerator-runtime/runtime.js ***!
    \********************************************************************************************************/
  /*! no static exports found */
  /***/function node_modulesBabelRuntimeNode_modulesRegeneratorRuntimeRuntimeJs(module, exports) {

    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    !function (global) {
      "use strict";

      var Op = Object.prototype;
      var hasOwn = Op.hasOwnProperty;
      var undefined; // More compressible than void 0.
      var $Symbol = typeof Symbol === "function" ? Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

      var inModule = (typeof module === 'undefined' ? 'undefined' : _typeof2(module)) === "object";
      var runtime = global.regeneratorRuntime;
      if (runtime) {
        if (inModule) {
          // If regeneratorRuntime is defined globally and we're in a module,
          // make the exports object identical to regeneratorRuntime.
          module.exports = runtime;
        }
        // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.
        return;
      }

      // Define the runtime globally (as expected by generated code) as either
      // module.exports (if we're in a module) or a new, empty object.
      runtime = global.regeneratorRuntime = inModule ? module.exports : {};

      function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);

        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self, context);

        return generator;
      }
      runtime.wrap = wrap;

      // Try/catch helper to minimize deoptimizations. Returns a completion
      // record like context.tryEntries[i].completion. This interface could
      // have been (and was previously) designed to take a closure to be
      // invoked without arguments, but in all the cases we care about we
      // already have an existing method we want to call, so there's no need
      // to create a new function object. We can even get away with assuming
      // the method takes exactly one argument, since that happens to be true
      // in every case, so we don't have to touch the arguments object. The
      // only additional allocation required is the completion record, which
      // has a stable shape and so hopefully should be cheap to allocate.
      function tryCatch(fn, obj, arg) {
        try {
          return { type: "normal", arg: fn.call(obj, arg) };
        } catch (err) {
          return { type: "throw", arg: err };
        }
      }

      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed";

      // Returning this object from the innerFn has the same effect as
      // breaking out of the dispatch switch statement.
      var ContinueSentinel = {};

      // Dummy constructor functions that we use as the .constructor and
      // .constructor.prototype properties for functions that return Generator
      // objects. For full spec compliance, you may wish to configure your
      // minifier not to mangle the names of these two functions.
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}

      // This is a polyfill for %IteratorPrototype% for environments that
      // don't natively support it.
      var IteratorPrototype = {};
      IteratorPrototype[iteratorSymbol] = function () {
        return this;
      };

      var getProto = Object.getPrototypeOf;
      var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
      if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
      }

      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
      GeneratorFunctionPrototype.constructor = GeneratorFunction;
      GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

      // Helper for defining the .next, .throw, and .return methods of the
      // Iterator interface in terms of a single ._invoke method.
      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          prototype[method] = function (arg) {
            return this._invoke(method, arg);
          };
        });
      }

      runtime.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };

      runtime.mark = function (genFun) {
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;
          if (!(toStringTagSymbol in genFun)) {
            genFun[toStringTagSymbol] = "GeneratorFunction";
          }
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
      };

      // Within the body of any async function, `await x` is transformed to
      // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
      // `hasOwn.call(value, "__await")` to determine if the yielded value is
      // meant to be awaited.
      runtime.awrap = function (arg) {
        return { __await: arg };
      };

      function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);
          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;
            if (value && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === "object" && hasOwn.call(value, "__await")) {
              return Promise.resolve(value.__await).then(function (value) {
                invoke("next", value, resolve, reject);
              }, function (err) {
                invoke("throw", err, resolve, reject);
              });
            }

            return Promise.resolve(value).then(function (unwrapped) {
              // When a yielded Promise is resolved, its final value becomes
              // the .value of the Promise<{value,done}> result for the
              // current iteration. If the Promise is rejected, however, the
              // result for this iteration will be rejected with the same
              // reason. Note that rejections of yielded Promises are not
              // thrown back into the generator function, as is the case
              // when an awaited Promise is rejected. This difference in
              // behavior between yield and await is important, because it
              // allows the consumer to decide what to do with the yielded
              // rejection (swallow it and continue, manually .throw it back
              // into the generator, abandon iteration, whatever). With
              // await, by contrast, there is no opportunity to examine the
              // rejection reason outside the generator function, so the
              // only option is to throw it from the await expression, and
              // let the generator function handle the exception.
              result.value = unwrapped;
              resolve(result);
            }, reject);
          }
        }

        var previousPromise;

        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new Promise(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }

          return previousPromise =
          // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }

        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
      }

      defineIteratorMethods(AsyncIterator.prototype);
      AsyncIterator.prototype[asyncIteratorSymbol] = function () {
        return this;
      };
      runtime.AsyncIterator = AsyncIterator;

      // Note that simple async functions are implemented on top of
      // AsyncIterator objects; they just return a Promise for the value of
      // the final result produced by the iterator.
      runtime.async = function (innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      };

      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;

        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }

          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            }

            // Be forgiving, per 25.3.3.3.3 of the spec:
            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
            return doneResult();
          }

          context.method = method;
          context.arg = arg;

          while (true) {
            var delegate = context.delegate;
            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);
              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }

            if (context.method === "next") {
              // Setting context._sent for legacy support of Babel's
              // function.sent implementation.
              context.sent = context._sent = context.arg;
            } else if (context.method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw context.arg;
              }

              context.dispatchException(context.arg);
            } else if (context.method === "return") {
              context.abrupt("return", context.arg);
            }

            state = GenStateExecuting;

            var record = tryCatch(innerFn, self, context);
            if (record.type === "normal") {
              // If an exception is thrown from innerFn, we leave state ===
              // GenStateExecuting and loop back for another invocation.
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;

              if (record.arg === ContinueSentinel) {
                continue;
              }

              return {
                value: record.arg,
                done: context.done
              };
            } else if (record.type === "throw") {
              state = GenStateCompleted;
              // Dispatch the exception by looping back around to the
              // context.dispatchException(context.arg) call above.
              context.method = "throw";
              context.arg = record.arg;
            }
          }
        };
      }

      // Call delegate.iterator[context.method](context.arg) and handle the
      // result, either by returning a { value, done } result from the
      // delegate iterator, or by modifying context.method and context.arg,
      // setting context.delegate to null, and returning the ContinueSentinel.
      function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
          // A .throw or .return when the delegate iterator has no .throw
          // method always terminates the yield* loop.
          context.delegate = null;

          if (context.method === "throw") {
            if (delegate.iterator.return) {
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              context.method = "return";
              context.arg = undefined;
              maybeInvokeDelegate(delegate, context);

              if (context.method === "throw") {
                // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
              }
            }

            context.method = "throw";
            context.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return ContinueSentinel;
        }

        var record = tryCatch(method, delegate.iterator, context.arg);

        if (record.type === "throw") {
          context.method = "throw";
          context.arg = record.arg;
          context.delegate = null;
          return ContinueSentinel;
        }

        var info = record.arg;

        if (!info) {
          context.method = "throw";
          context.arg = new TypeError("iterator result is not an object");
          context.delegate = null;
          return ContinueSentinel;
        }

        if (info.done) {
          // Assign the result of the finished delegate to the temporary
          // variable specified by delegate.resultName (see delegateYield).
          context[delegate.resultName] = info.value;

          // Resume execution at the desired location (see delegateYield).
          context.next = delegate.nextLoc;

          // If context.method was "throw" but the delegate handled the
          // exception, let the outer generator proceed normally. If
          // context.method was "next", forget context.arg since it has been
          // "consumed" by the delegate iterator. If context.method was
          // "return", allow the original .return call to continue in the
          // outer generator.
          if (context.method !== "return") {
            context.method = "next";
            context.arg = undefined;
          }
        } else {
          // Re-yield the result returned by the delegate method.
          return info;
        }

        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
      }

      // Define Generator.prototype.{next,throw,return} in terms of the
      // unified ._invoke helper method.
      defineIteratorMethods(Gp);

      Gp[toStringTagSymbol] = "Generator";

      // A Generator should always return itself as the iterator object when the
      // @@iterator function is called on it. Some browsers' implementations of the
      // iterator prototype chain incorrectly implement this, causing the Generator
      // object to not be returned from this call. This ensures that doesn't happen.
      // See https://github.com/facebook/regenerator/issues/274 for more details.
      Gp[iteratorSymbol] = function () {
        return this;
      };

      Gp.toString = function () {
        return "[object Generator]";
      };

      function pushTryEntry(locs) {
        var entry = { tryLoc: locs[0] };

        if (1 in locs) {
          entry.catchLoc = locs[1];
        }

        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }

        this.tryEntries.push(entry);
      }

      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }

      function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [{ tryLoc: "root" }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }

      runtime.keys = function (object) {
        var keys = [];
        for (var key in object) {
          keys.push(key);
        }
        keys.reverse();

        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
          while (keys.length) {
            var key = keys.pop();
            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          }

          // To avoid creating an additional object, we just hang the .value
          // and .done properties off the next function object itself. This
          // also ensures that the minifier will not anonymize the function.
          next.done = true;
          return next;
        };
      };

      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];
          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }

          if (typeof iterable.next === "function") {
            return iterable;
          }

          if (!isNaN(iterable.length)) {
            var i = -1,
                next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }

              next.value = undefined;
              next.done = true;

              return next;
            };

            return next.next = next;
          }
        }

        // Return an iterator with no values.
        return { next: doneResult };
      }
      runtime.values = values;

      function doneResult() {
        return { value: undefined, done: true };
      }

      Context.prototype = {
        constructor: Context,

        reset: function reset(skipTempReset) {
          this.prev = 0;
          this.next = 0;
          // Resetting context._sent for legacy support of Babel's
          // function.sent implementation.
          this.sent = this._sent = undefined;
          this.done = false;
          this.delegate = null;

          this.method = "next";
          this.arg = undefined;

          this.tryEntries.forEach(resetTryEntry);

          if (!skipTempReset) {
            for (var name in this) {
              // Not sure about the optimal order of these conditions:
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined;
              }
            }
          }
        },

        stop: function stop() {
          this.done = true;

          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;
          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }

          return this.rval;
        },

        dispatchException: function dispatchException(exception) {
          if (this.done) {
            throw exception;
          }

          var context = this;
          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;

            if (caught) {
              // If the dispatched exception was caught by a catch block,
              // then let that catch block handle the exception normally.
              context.method = "next";
              context.arg = undefined;
            }

            return !!caught;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;

            if (entry.tryLoc === "root") {
              // Exception thrown outside of any try block that could handle
              // it, so set the completion value of the entire function to
              // throw the exception.
              return handle("end");
            }

            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");

              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },

        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }

          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
          }

          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;

          if (finallyEntry) {
            this.method = "next";
            this.next = finallyEntry.finallyLoc;
            return ContinueSentinel;
          }

          return this.complete(record);
        },

        complete: function complete(record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }

          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = this.arg = record.arg;
            this.method = "return";
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }

          return ContinueSentinel;
        },

        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },

        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;
              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }
              return thrown;
            }
          }

          // The context.catch method must only be called with a location
          // argument that corresponds to a known catch block.
          throw new Error("illegal catch attempt");
        },

        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };

          if (this.method === "next") {
            // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
          }

          return ContinueSentinel;
        }
      };
    }(
    // In sloppy mode, unbound `this` refers to the global object, fallback to
    // Function constructor if we're in global strict mode. That is sadly a form
    // of indirect eval which violates Content Security Policy.
    function () {
      return this;
    }() || Function("return this")());

    /***/
  },

  /***/"../../node_modules/babel-runtime/regenerator/index.js":
  /*!*********************************************************************************!*\
    !*** /Users/santi/code/example/node_modules/babel-runtime/regenerator/index.js ***!
    \*********************************************************************************/
  /*! no static exports found */
  /***/function node_modulesBabelRuntimeRegeneratorIndexJs(module, exports, __webpack_require__) {

    module.exports = __webpack_require__( /*! regenerator-runtime */"../../node_modules/babel-runtime/node_modules/regenerator-runtime/runtime-module.js");

    /***/
  },

  /***/"../../node_modules/safe-access/index.js":
  /*!*******************************************************************!*\
    !*** /Users/santi/code/example/node_modules/safe-access/index.js ***!
    \*******************************************************************/
  /*! no static exports found */
  /***/function node_modulesSafeAccessIndexJs(module, exports) {

    module.exports = function access(obj, accessStr) {
      // auto-curry here
      if (isUndefined(accessStr)) {
        return access.bind(null, obj);
      }

      var funcArgs = Array.prototype.slice.call(arguments, 2);
      return helper(obj, tokenize(accessStr), null, funcArgs);
    };

    function helper(obj, tokens, ctx, fnArgs) {
      if (tokens.length === 0) {
        return obj;
      }

      var currentToken = tokens[0];

      if (isUndefined(obj) || isNull(obj) || isTokenFunctionCall(currentToken) && !isFunction(obj)) {
        return undefined;
      }

      if (isTokenFunctionCall(currentToken)) {

        return helper(obj[isArray(fnArgs[0]) ? 'apply' : 'call'](ctx, fnArgs[0]), tokens.slice(1),
        // clear context because consecutive fn calls execute in global context
        // e.g. `a.b()()`
        null, fnArgs.slice(1));
      } else if (isTokenArrayAccess(currentToken)) {

        return helper(obj[parseInt(currentToken.substr(1), 10)], tokens.slice(1),
        // lookahead two tokens for function calls
        isTokenFunctionCall(tokens[1]) ? obj : ctx, fnArgs);
      } else {

        return helper(obj[currentToken], tokens.slice(1),
        // lookahead two tokens for function calls
        isTokenFunctionCall(tokens[1]) ? obj : ctx, fnArgs);
      }
    }

    function isUndefined(a) {
      return a === void 0;
    }

    function isNull(a) {
      return a === null;
    }

    function isArray(a) {
      return Array.isArray(a);
    }

    function isFunction(a) {
      return typeof a === 'function';
    }

    function isTokenFunctionCall(token) {
      return token === '()';
    }

    function isTokenArrayAccess(token) {
      return (/^\[\d+\]$/.test(token)
      );
    }

    function tokenize(str) {
      return str.split(/\.|(\(\))|(\[\d+?])/).filter(function (t) {
        return t;
      });
    }

    /***/
  },

  /***/"./src/basic.functions.js":
  /*!********************************!*\
    !*** ./src/basic.functions.js ***!
    \********************************/
  /*! exports provided: safe, get, assign, keys, k, values, v, merge, m, rollup, rollupWithKey, flattenArrs, flattenDeep, valuesWithKey, shallowClone, arrayClone, kv, asArray, pairs, kvr, objMap, objForEach, doAsync, isArray, isArr, isString, isFn, isBool, isObj, noop, sleep, wait, rand, unique, arrayOf, ellipsis, distinct, timeout, findUndefined, ensureParamsProvided, compareByKeyValue, encodeForFbKey, decodeFromFbKey, thingsAreStrictlyEqual, arraysHaveSameItems, arraysAreSame, arrayComparator, areShallowEquivalent, compareWithJSONStringify, sameRef, sr, createCallLimit, createPropComparator, Emitter, trimStart, throttle, debounce */
  /***/function srcBasicFunctionsJs(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "safe", function () {
      return safe;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "get", function () {
      return get;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "assign", function () {
      return assign;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "keys", function () {
      return keys;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "k", function () {
      return k;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "values", function () {
      return values;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "v", function () {
      return v;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "merge", function () {
      return merge;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "m", function () {
      return m;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "rollup", function () {
      return rollup;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "rollupWithKey", function () {
      return rollupWithKey;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "flattenArrs", function () {
      return flattenArrs;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "flattenDeep", function () {
      return flattenDeep;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "valuesWithKey", function () {
      return valuesWithKey;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "shallowClone", function () {
      return shallowClone;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "arrayClone", function () {
      return arrayClone;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "kv", function () {
      return kv;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "asArray", function () {
      return asArray;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "pairs", function () {
      return pairs;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "kvr", function () {
      return kvr;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "objMap", function () {
      return objMap;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "objForEach", function () {
      return objForEach;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "doAsync", function () {
      return doAsync;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "isArray", function () {
      return isArray;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "isArr", function () {
      return isArr;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "isString", function () {
      return isString;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "isFn", function () {
      return isFn;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "isBool", function () {
      return isBool;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "isObj", function () {
      return isObj;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "noop", function () {
      return noop;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "sleep", function () {
      return sleep;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "wait", function () {
      return wait;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "rand", function () {
      return rand;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "unique", function () {
      return unique;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "arrayOf", function () {
      return arrayOf;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "ellipsis", function () {
      return ellipsis;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "distinct", function () {
      return distinct;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "timeout", function () {
      return timeout;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "findUndefined", function () {
      return findUndefined;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "ensureParamsProvided", function () {
      return ensureParamsProvided;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "compareByKeyValue", function () {
      return compareByKeyValue;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "encodeForFbKey", function () {
      return encodeForFbKey;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "decodeFromFbKey", function () {
      return decodeFromFbKey;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "thingsAreStrictlyEqual", function () {
      return thingsAreStrictlyEqual;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "arraysHaveSameItems", function () {
      return arraysHaveSameItems;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "arraysAreSame", function () {
      return arraysAreSame;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "arrayComparator", function () {
      return arrayComparator;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "areShallowEquivalent", function () {
      return areShallowEquivalent;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "compareWithJSONStringify", function () {
      return compareWithJSONStringify;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "sameRef", function () {
      return sameRef;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "sr", function () {
      return sr;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "createCallLimit", function () {
      return createCallLimit;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "createPropComparator", function () {
      return createPropComparator;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "Emitter", function () {
      return Emitter;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "trimStart", function () {
      return trimStart;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "throttle", function () {
      return throttle;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "debounce", function () {
      return debounce;
    });
    /* harmony import */var babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! babel-runtime/regenerator */"../../node_modules/babel-runtime/regenerator/index.js");
    /* harmony import */var babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */var safe_access__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! safe-access */"../../node_modules/safe-access/index.js");
    /* harmony import */var safe_access__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(safe_access__WEBPACK_IMPORTED_MODULE_1__);

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
      }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
      };
    }();

    var _this = undefined;

    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }return arr2;
      } else {
        return Array.from(arr);
      }
    }

    function _asyncToGenerator(fn) {
      return function () {
        var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
          function step(key, arg) {
            try {
              var info = gen[key](arg);var value = info.value;
            } catch (error) {
              reject(error);return;
            }if (info.done) {
              resolve(value);
            } else {
              return Promise.resolve(value).then(function (value) {
                step("next", value);
              }, function (err) {
                step("throw", err);
              });
            }
          }return step("next");
        });
      };
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }return obj;
    }

    var safe = safe_access__WEBPACK_IMPORTED_MODULE_1___default.a;
    var get = safe;
    var assign = Object.assign;
    var keys = function keys(obj) {
      return Object.keys(obj || {});
    };
    var k = keys;
    var values = function values(obj) {
      return keys(obj).map(function (k) {
        return obj[k];
      });
    };
    var v = values;
    var merge = function merge() {
      for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
        objs[_key] = arguments[_key];
      }

      return Object.assign.apply(Object, [{}].concat(objs));
    };
    var m = merge;
    var rollup = function rollup(arr, deriveValue, deriveKey) {
      var defaultDeriveValue = function defaultDeriveValue() {
        return true;
      };
      var defaultDeriveKey = function defaultDeriveKey(item) {
        return '' + item;
      };
      var args = {};
      if (Array.isArray(arr)) {
        args.arr = arr;
        args.deriveValue = deriveValue || defaultDeriveValue;
        args.deriveKey = deriveKey || defaultDeriveKey;
      } else if ((typeof arr === 'undefined' ? 'undefined' : _typeof(arr)) === 'object' && !!arr) {
        args.arr = arr.array;
        args.deriveValue = arr.deriveValue || defaultDeriveValue;
        args.deriveKey = arr.deriveKey || defaultDeriveKey;
      }
      return args.arr.reduce(function (obj, item) {
        return merge(obj, _defineProperty({}, args.deriveKey(item), args.deriveValue(item)));
      }, {});
    };
    var rollupWithKey = function rollupWithKey() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var deriveKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
        return null;
      };
      return rollup(arr, function (item) {
        return item;
      }, deriveKey);
    };
    var flattenArrs = function flattenArrs(arrs) {
      return arrs.reduce(function (flat, arr) {
        return flat.concat(arr);
      }, []);
    };
    var flattenDeep = function flattenDeep(arr) {
      return arr.reduce(function (f, i) {
        return f.concat(Array.isArray(i) ? flattenDeep(i) : i);
      }, []);
    };
    var valuesWithKey = function valuesWithKey(obj) {
      return keys(obj).map(function (k) {
        return merge(obj[k], { _key: k });
      });
    };
    var shallowClone = merge;
    var arrayClone = function arrayClone(arr) {
      return arr.slice(0);
    };
    var kv = function kv(obj) {
      var propMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { k: 'k', v: 'v' };
      return keys(obj).map(function (k) {
        var _ref;

        return _ref = {}, _defineProperty(_ref, propMap['k'], k), _defineProperty(_ref, propMap['v'], obj[k]), _ref;
      });
    };
    var asArray = function asArray(obj) {
      return Object.keys(obj).map(function (k) {
        return Object.assign({}, obj[k], { _key: k });
      });
    };
    var pairs = kv;
    var kvr = function kvr(kv) {
      return kv.reduce(function (o, _ref2) {
        var k = _ref2.k,
            v = _ref2.v;
        return merge(o, _defineProperty({}, k, v));
      }, {});
    };
    var objMap = function objMap(obj, fn) {
      return kv(obj).reduce(function (o, _ref3) {
        var k = _ref3.k,
            v = _ref3.v;
        return merge(o, _defineProperty({}, k, fn(v, k)));
      }, {});
    };
    var objForEach = objMap;
    var doAsync = function doAsync(fn) {
      var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return new Promise(function (resolve) {
        return setTimeout(function () {
          return resolve(fn());
        }, ms);
      });
    };
    var isArray = function isArray(thing) {
      return Array.isArray(thing);
    };
    var isArr = isArray;
    var isString = function isString(thing) {
      return typeof thing === 'string';
    };
    var isFn = function isFn(thing) {
      return typeof thing === 'function';
    };
    var isBool = function isBool(thing) {
      return typeof thing === 'boolean';
    };
    var isObj = function isObj() {
      for (var _len2 = arguments.length, things = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        things[_key2] = arguments[_key2];
      }

      return things.every(function (thing) {
        return (typeof thing === 'undefined' ? 'undefined' : _typeof(thing)) === 'object' && !!thing;
      });
    };
    var noop = function noop() {
      return undefined;
    };
    var sleep = function sleep(ms) {
      return new Promise(function (r) {
        return setTimeout(r, ms);
      });
    };
    var wait = sleep;
    var rand = function rand() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
      return Math.floor(Math.random() * to) + from;
    };
    var unique = function unique() {
      for (var _len3 = arguments.length, arrs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        arrs[_key3] = arguments[_key3];
      }

      return Array.from(new Set(arrs.reduce(function (c, a) {
        return c.concat(a);
      })));
    };
    var arrayOf = function arrayOf() {
      var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return new Array(length).fill(true);
    };
    var ellipsis = function ellipsis() {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var maxLength = arguments[1];
      return str.length > maxLength ? str.substring(0, maxLength).trim() + '...' : str;
    };
    var distinct = unique;
    var timeout = function timeout() {
      var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return null;
      };
      var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return new Promise(function (resolve) {
        return setTimeout(_asyncToGenerator( /*#__PURE__*/babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
          return babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return fn();

                case 2:
                  resolve();
                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        })), ms);
      });
    };

    var findUndefined = function findUndefined(obj) {
      var undef = kv(obj).find(function (_ref5) {
        var v = _ref5.v;
        return v === undefined;
      });
      if (!undef) return null;else return undef.k;
    };

    var ensureParamsProvided = function ensureParamsProvided(params) {
      var paramNotProvided = findUndefined(params);
      if (paramNotProvided) throw new Error(paramNotProvided + ' not provided');
    };

    var compareByKeyValue = function compareByKeyValue(obj1, obj2) {
      if (obj1 === obj2) return true;
      if (obj1 === null || obj2 === null) return false;
      var k1 = k(obj1);
      var k2 = k(obj2);
      return k1.length === k2.length && k1.every(function (k) {
        return obj1[k] === obj2[k];
      });
    };

    var encodeForFbKey = function encodeForFbKey(str) {
      return str.replace(/\./g, '_x_dot_x_');
    };

    var decodeFromFbKey = function decodeFromFbKey(str) {
      return str.replace(/_x_dot_x_/g, '.');
    };

    var thingsAreStrictlyEqual = function thingsAreStrictlyEqual(i1, i2) {
      return i1 === i2;
    };

    var arraysHaveSameItems = function arraysHaveSameItems(arr1, arr2) {
      var itemsAreEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : thingsAreStrictlyEqual;

      if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
      if (arr1.length !== arr2.length) return false;
      return arr1.every(function (i1) {
        return arr2.some(function (i2) {
          return itemsAreEqual(i1, i2);
        });
      });
    };

    var arraysAreSame = function arraysAreSame(arr1, arr2) {
      var itemsAreEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : thingsAreStrictlyEqual;

      if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false;
      if (arr1.length !== arr2.length) return false;
      for (var i = 0; i < arr1.length; i++) {
        if (!itemsAreEqual(arr1[i], arr2[i])) return false;
      }return true;
    };

    var arrayComparator = function arrayComparator() {
      var itemsAreEqual = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : thingsAreStrictlyEqual;
      return function (arr1, arr2) {
        return arraysAreSame(arr1, arr2, itemsAreEqual);
      };
    };

    var areShallowEquivalent = function areShallowEquivalent(thing1, thing2) {
      if ((typeof thing1 === 'undefined' ? 'undefined' : _typeof(thing1)) !== (typeof thing2 === 'undefined' ? 'undefined' : _typeof(thing2))) return false;
      if (Array.isArray(thing1) && !Array.isArray(thing2)) return false;
      if (Array.isArray(thing2) && !Array.isArray(thing1)) return false;
      if (Array.isArray(thing1)) return arraysAreSame(thing1, thing2);
      if ((typeof thing1 === 'undefined' ? 'undefined' : _typeof(thing1)) === 'object') return compareByKeyValue(thing1, thing2);
      return thing1 === thing2;
    };

    var compareWithJSONStringify = function compareWithJSONStringify(thing1, thing2) {
      return JSON.stringify(thing1) === JSON.stringify(thing2);
    };

    var sameRef = function sameRef(fn) {
      var isEquivalent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : areShallowEquivalent;

      var _cachedResult = void 0;
      return function () {

        var newResult = fn.apply(undefined, arguments);

        if (typeof _cachedResult === 'undefined' || !isEquivalent(_cachedResult, newResult)) {
          _cachedResult = newResult;
        }

        return _cachedResult;
      };
    };

    // same ref
    var sr = function sr() {
      var checkSame = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (v1, v2) {
        return v1 === v2;
      };

      var cached = void 0;
      return function (val) {
        var isSame = checkSame(cached, val);
        if (!isSame) cached = val;
        return cached;
      };
    };

    var createCallLimit = function createCallLimit(max) {
      var count = void 0;
      return function () {
        if (count++ > max) return false;
        return true;
      };
    };

    var createPropComparator = function createPropComparator() {
      var last = {};
      return function (next) {
        var allKeys = distinct([].concat(_toConsumableArray(k(last)), _toConsumableArray(k(next))));
        var updatedProps = allKeys.filter(function (key) {
          return last[key] !== next[key];
        }).map(function (key) {
          return { key: key, prev: last[key], next: next[key] };
        });
        last = next;
        return updatedProps;
      };
    };

    var Emitter = function () {
      function Emitter() {
        _classCallCheck(this, Emitter);

        this.handlers = [];this.last = undefined;
      }

      _createClass(Emitter, [{
        key: 'subscribe',
        value: function subscribe(handler) {
          this.handlers.push(handler);
        }
      }, {
        key: 'unsubscribe',
        value: function unsubscribe(handler) {
          this.handlers = this.handlers.filter(function (h) {
            return h !== handler;
          });
        }
      }, {
        key: 'emit',
        value: function emit(result) {
          this.last = result;this.handlers.forEach(function (handler) {
            return handler(result);
          });
        }
      }]);

      return Emitter;
    }();

    var trimStart = function trimStart(str) {
      if (str.trimStart) return str.trimStart();
      if (str.trimLeft) return str.trimLeft();
      var trimmed = str.trim();
      var startIndex = str.indexOf(trimmed);
      return str.slice(startIndex, str.length);
    };

    var throttle = function throttle(func, limit) {
      var lastFunc = void 0;
      var lastRan = void 0;
      return function () {
        var context = this;
        var args = arguments;
        if (!lastRan) {
          func.apply(context, args);
          lastRan = Date.now();
        } else {
          clearTimeout(lastFunc);
          lastFunc = setTimeout(function () {
            if (Date.now() - lastRan >= limit) {
              func.apply(context, args);
              lastRan = Date.now();
            }
          }, limit - (Date.now() - lastRan));
        }
      };
    };

    var debounce = function debounce(func, delay) {
      var inDebounce = void 0;
      return function () {
        var context = this;
        var args = arguments;
        clearTimeout(inDebounce);
        inDebounce = setTimeout(function () {
          return func.apply(context, args);
        }, delay);
      };
    };

    /***/
  },

  /***/"./src/immutable.functions.js":
  /*!************************************!*\
    !*** ./src/immutable.functions.js ***!
    \************************************/
  /*! exports provided: get, set, unset, ImmutableReadOnly, Immutable, g, s, u */
  /***/function srcImmutableFunctionsJs(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "get", function () {
      return get;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "set", function () {
      return set;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "unset", function () {
      return unset;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "ImmutableReadOnly", function () {
      return ImmutableReadOnly;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "Immutable", function () {
      return Immutable;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "g", function () {
      return g;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "s", function () {
      return s;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "u", function () {
      return u;
    });
    /* harmony import */var safe_access__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! safe-access */"../../node_modules/safe-access/index.js");
    /* harmony import */var safe_access__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(safe_access__WEBPACK_IMPORTED_MODULE_0__);
    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
      }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
      };
    }();

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
      }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
      } else {
        obj[key] = value;
      }return obj;
    }

    var DELETE_FLAG = '__*delete*__';

    var _setAtPathInternal = function _setAtPathInternal() {
      var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pathArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var value = arguments[2];

      if (!pathArray.length) throw new Error('INVALID PATH ARRAY');else if (pathArray.length === 1) {
        var clone = Object.assign({}, object);
        if (value === DELETE_FLAG) delete clone[pathArray[0]];else clone[pathArray[0]] = value;
        return clone;
      } else return Object.assign({}, object, _defineProperty({}, pathArray[0], _setAtPathInternal(object[pathArray[0]], pathArray.slice(1), value)));
    };

    var _setAtPath = function _setAtPath() {
      var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'example.path';
      var value = arguments[2];

      return _setAtPathInternal(object, path.split('.'), value);
    };

    var _applyTransitionMap = function _applyTransitionMap(state, transitionMap) {
      return Object.keys(transitionMap).reduce(function (nextStateInConstruction, path) {
        var prevSubState = safe_access__WEBPACK_IMPORTED_MODULE_0___default()(state, path);
        var nextSubState = typeof transitionMap[path] === 'function' ? transitionMap[path](prevSubState, state) : transitionMap[path];
        return _setAtPath(nextStateInConstruction, path, nextSubState);
      }, state);
    };

    var get = function get() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var path = arguments[1];
      return safe_access__WEBPACK_IMPORTED_MODULE_0___default()(obj, path);
    };
    var set = function set() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var transitionMap = arguments[1];
      return _applyTransitionMap(obj, transitionMap);
    };
    var unset = function unset() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var paths = arguments[1];

      var pathsArray = Array.isArray(paths) ? paths : [paths];
      var transitionMap = pathsArray.reduce(function (tm, p) {
        return Object.assign(_defineProperty({}, p, DELETE_FLAG), tm);
      }, {});
      return set(obj, transitionMap);
    };

    var ImmutableReadOnly = function () {
      function ImmutableReadOnly(raw) {
        _classCallCheck(this, ImmutableReadOnly);

        this._raw = raw;
      }

      _createClass(ImmutableReadOnly, [{
        key: 'wrap',
        value: function wrap(raw) {
          return this.constructor.wrap(raw);
        }
      }, {
        key: 'raw',
        value: function raw() {
          return this._raw;
        }
      }, {
        key: 'get',
        value: function get() {
          return this._get.apply(this, arguments);
        }
      }, {
        key: '_get',
        value: function _get(path) {
          if (!path) return this._raw;
          return g(this._raw, path);
        }
      }], [{
        key: 'wrap',
        value: function wrap(raw) {
          return new this(raw);
        }
      }]);

      return ImmutableReadOnly;
    }();

    var Immutable = function (_ImmutableReadOnly) {
      _inherits(Immutable, _ImmutableReadOnly);

      function Immutable() {
        _classCallCheck(this, Immutable);

        return _possibleConstructorReturn(this, (Immutable.__proto__ || Object.getPrototypeOf(Immutable)).apply(this, arguments));
      }

      _createClass(Immutable, [{
        key: 'set',
        value: function set() {
          return this._set.apply(this, arguments);
        }
      }, {
        key: '_set',
        value: function _set(transitionMapOrPath, valueOrNothing) {
          var transitionMap = void 0;
          if ((typeof transitionMapOrPath === 'undefined' ? 'undefined' : _typeof(transitionMapOrPath)) === 'object') transitionMap = transitionMapOrPath;else if (typeof transitionMapOrPath === 'string') transitionMap = _defineProperty({}, transitionMapOrPath, valueOrNothing);

          return this.wrap(s(this._get(), transitionMap));
        }
      }]);

      return Immutable;
    }(ImmutableReadOnly);

    var g = get;
    var s = set;
    var u = unset;

    /***/
  },

  /***/"./src/index.js":
  /*!**********************!*\
    !*** ./src/index.js ***!
    \**********************/
  /*! exports provided: safe, get, assign, keys, k, values, v, merge, m, rollup, rollupWithKey, flattenArrs, flattenDeep, valuesWithKey, shallowClone, arrayClone, kv, asArray, pairs, kvr, objMap, objForEach, doAsync, isArray, isArr, isString, isFn, isBool, isObj, noop, sleep, wait, rand, unique, arrayOf, ellipsis, distinct, timeout, findUndefined, ensureParamsProvided, compareByKeyValue, encodeForFbKey, decodeFromFbKey, thingsAreStrictlyEqual, arraysHaveSameItems, arraysAreSame, arrayComparator, areShallowEquivalent, compareWithJSONStringify, sameRef, sr, createCallLimit, createPropComparator, Emitter, trimStart, throttle, debounce, encodeEmail, decodeEamil, flatMap, assert, howLongAgo, howLongFromNow, isToday, isThisYear, consoleOutUpdatedProps, consoleOutUpdatedState, routerPrefix, router, set, unset, ImmutableReadOnly, Immutable, g, s, u */
  /***/function srcIndexJs(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */var _basic_functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./basic.functions */"./src/basic.functions.js");
    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "safe", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["safe"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "get", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["get"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "assign", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["assign"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "keys", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["keys"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "k", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["k"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "values", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["values"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "v", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["v"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "merge", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["merge"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "m", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["m"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "rollup", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["rollup"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "rollupWithKey", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["rollupWithKey"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "flattenArrs", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["flattenArrs"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "flattenDeep", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["flattenDeep"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "valuesWithKey", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["valuesWithKey"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "shallowClone", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["shallowClone"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "arrayClone", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["arrayClone"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "kv", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["kv"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "asArray", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["asArray"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "pairs", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["pairs"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "kvr", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["kvr"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "objMap", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["objMap"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "objForEach", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["objForEach"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "doAsync", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["doAsync"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "isArray", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["isArray"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "isArr", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["isArr"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "isString", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["isString"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "isFn", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["isFn"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "isBool", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["isBool"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "isObj", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["isObj"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "noop", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["noop"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "sleep", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["sleep"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "wait", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["wait"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "rand", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["rand"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "unique", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["unique"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "arrayOf", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["arrayOf"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "ellipsis", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["ellipsis"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "distinct", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["distinct"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "timeout", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["timeout"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "findUndefined", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["findUndefined"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "ensureParamsProvided", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["ensureParamsProvided"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "compareByKeyValue", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["compareByKeyValue"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "encodeForFbKey", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["encodeForFbKey"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "decodeFromFbKey", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["decodeFromFbKey"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "thingsAreStrictlyEqual", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["thingsAreStrictlyEqual"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "arraysHaveSameItems", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["arraysHaveSameItems"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "arraysAreSame", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["arraysAreSame"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "arrayComparator", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["arrayComparator"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "areShallowEquivalent", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["areShallowEquivalent"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "compareWithJSONStringify", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["compareWithJSONStringify"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "sameRef", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["sameRef"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "sr", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["sr"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "createCallLimit", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["createCallLimit"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "createPropComparator", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["createPropComparator"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "Emitter", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["Emitter"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "trimStart", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["trimStart"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "throttle", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["throttle"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "debounce", function () {
      return _basic_functions__WEBPACK_IMPORTED_MODULE_0__["debounce"];
    });

    /* harmony import */var _misc_functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./misc.functions */"./src/misc.functions.js");
    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "encodeEmail", function () {
      return _misc_functions__WEBPACK_IMPORTED_MODULE_1__["encodeEmail"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "decodeEamil", function () {
      return _misc_functions__WEBPACK_IMPORTED_MODULE_1__["decodeEamil"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "flatMap", function () {
      return _misc_functions__WEBPACK_IMPORTED_MODULE_1__["flatMap"];
    });

    /* harmony import */var _testing_functions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./testing.functions */"./src/testing.functions.js");
    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "assert", function () {
      return _testing_functions__WEBPACK_IMPORTED_MODULE_2__["assert"];
    });

    /* harmony import */var _time_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./time.functions */"./src/time.functions.js");
    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "howLongAgo", function () {
      return _time_functions__WEBPACK_IMPORTED_MODULE_3__["howLongAgo"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "howLongFromNow", function () {
      return _time_functions__WEBPACK_IMPORTED_MODULE_3__["howLongFromNow"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "isToday", function () {
      return _time_functions__WEBPACK_IMPORTED_MODULE_3__["isToday"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "isThisYear", function () {
      return _time_functions__WEBPACK_IMPORTED_MODULE_3__["isThisYear"];
    });

    /* harmony import */var _react_functions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./react.functions */"./src/react.functions.js");
    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "consoleOutUpdatedProps", function () {
      return _react_functions__WEBPACK_IMPORTED_MODULE_4__["consoleOutUpdatedProps"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "consoleOutUpdatedState", function () {
      return _react_functions__WEBPACK_IMPORTED_MODULE_4__["consoleOutUpdatedState"];
    });

    /* harmony import */var _react_router_functions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./react-router.functions */"./src/react-router.functions.js");
    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "routerPrefix", function () {
      return _react_router_functions__WEBPACK_IMPORTED_MODULE_5__["routerPrefix"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "router", function () {
      return _react_router_functions__WEBPACK_IMPORTED_MODULE_5__["router"];
    });

    /* harmony import */var _immutable_functions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ./immutable.functions */"./src/immutable.functions.js");
    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "set", function () {
      return _immutable_functions__WEBPACK_IMPORTED_MODULE_6__["set"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "unset", function () {
      return _immutable_functions__WEBPACK_IMPORTED_MODULE_6__["unset"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "ImmutableReadOnly", function () {
      return _immutable_functions__WEBPACK_IMPORTED_MODULE_6__["ImmutableReadOnly"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "Immutable", function () {
      return _immutable_functions__WEBPACK_IMPORTED_MODULE_6__["Immutable"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "g", function () {
      return _immutable_functions__WEBPACK_IMPORTED_MODULE_6__["g"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "s", function () {
      return _immutable_functions__WEBPACK_IMPORTED_MODULE_6__["s"];
    });

    /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "u", function () {
      return _immutable_functions__WEBPACK_IMPORTED_MODULE_6__["u"];
    });

    /***/
  },

  /***/"./src/misc.functions.js":
  /*!*******************************!*\
    !*** ./src/misc.functions.js ***!
    \*******************************/
  /*! exports provided: keys, values, pairs, merge, encodeEmail, decodeEamil, flatMap, throttle, debounce */
  /***/function srcMiscFunctionsJs(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "keys", function () {
      return keys;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "values", function () {
      return values;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "pairs", function () {
      return pairs;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "merge", function () {
      return merge;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "encodeEmail", function () {
      return encodeEmail;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "decodeEamil", function () {
      return decodeEamil;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "flatMap", function () {
      return flatMap;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "throttle", function () {
      return throttle;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "debounce", function () {
      return debounce;
    });
    var keys = function keys(obj) {
      return Object.keys(obj || {});
    };
    var values = function values(obj) {
      return Object.values(obj || {});
    };
    var pairs = function pairs(obj) {
      return keys(obj).map(function (k) {
        return { k: k, v: obj[k] };
      });
    };
    var merge = function merge() {
      for (var _len = arguments.length, objs = Array(_len), _key = 0; _key < _len; _key++) {
        objs[_key] = arguments[_key];
      }

      return Object.assign.apply(Object, [{}].concat(objs));
    };
    var encodeEmail = function encodeEmail(email) {
      return email.replace(/\./g, ',');
    };
    var decodeEamil = function decodeEamil(email) {
      return email.replace(/,/g, '.');
    };
    var flatMap = function flatMap(arr) {
      return function (mapFunc) {
        return (arr || []).map(mapFunc).reduce(function (flat, item) {
          return flat.concat(Array.isArray(item) ? item : [item]);
        }, []);
      };
    };

    var throttle = function throttle(func, delay) {
      var timeout = void 0;
      return function () {
        if (!timeout) {
          func();
          timeout = setTimeout(function () {
            timeout = null;
          }, delay);
        }
      };
    };
    var debounce = function debounce(func, delay) {
      var timeout = void 0;
      return function () {
        if (timeout) {
          clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
          func();
        }, delay);
      };
    };

    /***/
  },

  /***/"./src/react-router.functions.js":
  /*!***************************************!*\
    !*** ./src/react-router.functions.js ***!
    \***************************************/
  /*! exports provided: routerPrefix, router */
  /***/function srcReactRouterFunctionsJs(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "routerPrefix", function () {
      return routerPrefix;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "router", function () {
      return router;
    });
    var routerPrefix = function routerPrefix(match) {
      if (!match || !match.url) return '';
      var prefix = match.url;
      if (prefix[prefix.length - 1] === '/') prefix = prefix.substr(0, prefix.length - 1);
      return prefix;
    };

    var relativeLocation = function relativeLocation(location, prefix) {
      return location.pathname.substr(prefix.length);
    };

    var parseCurrentRoute = function parseCurrentRoute(_ref) {
      var match = _ref.match,
          location = _ref.location;

      var prefix = routerPrefix(match);
      var relloc = relativeLocation(location, prefix);
      var rellocArr = relloc.split('/').slice(1);
      return { prefix: prefix, relloc: relloc, rellocArr: rellocArr };
    };

    var router = {
      parseCurrentRoute: parseCurrentRoute,
      routerPrefix: routerPrefix,
      relativeLocation: relativeLocation
    };

    /***/
  },

  /***/"./src/react.functions.js":
  /*!********************************!*\
    !*** ./src/react.functions.js ***!
    \********************************/
  /*! exports provided: consoleOutUpdatedProps, consoleOutUpdatedState */
  /***/function srcReactFunctionsJs(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "consoleOutUpdatedProps", function () {
      return consoleOutUpdatedProps;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "consoleOutUpdatedState", function () {
      return consoleOutUpdatedState;
    });
    var consoleOutUpdatedProps = function consoleOutUpdatedProps(_this) {
      var v = Object.values(_this.props);
      var k = Object.keys(_this.props);
      var lv = Object.values(_this.__lastProps || {});
      var lk = Object.keys(_this.__lastProps || {});

      // @todo: ignores props that disappeared
      var updatedProps = v.filter(function (i) {
        return !lv.includes(i);
      }).map(function (i) {
        return k[v.indexOf(i)];
      });

      if (updatedProps.length) console.log(_this.constructor.name + ' props updated', updatedProps);

      _this.__lastProps = _this.props;
    };

    var consoleOutUpdatedState = function consoleOutUpdatedState(_this) {
      var v = Object.values(_this.state);
      var k = Object.keys(_this.state);
      var lv = Object.values(_this.__lastState || {});
      var lk = Object.keys(_this.__lastState || {});

      // @todo: ignores state that disappeared
      var updatedState = v.filter(function (i) {
        return !lv.includes(i);
      }).map(function (i) {
        return k[v.indexOf(i)];
      });

      if (updatedState.length) console.log(_this.constructor.name + ' state updated', updatedState);

      _this.__lastState = _this.state;
    };

    /***/
  },

  /***/"./src/testing.functions.js":
  /*!**********************************!*\
    !*** ./src/testing.functions.js ***!
    \**********************************/
  /*! exports provided: assert */
  /***/function srcTestingFunctionsJs(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "assert", function () {
      return assert;
    });
    var assert = function assert(assertions) {
      if (!expect) throw new Error('assert() can only be used in a testing environment');
      assertions.forEach(function (a) {
        return expect(a).toBeTruthy();
      });
    };

    /***/
  },

  /***/"./src/time.functions.js":
  /*!*******************************!*\
    !*** ./src/time.functions.js ***!
    \*******************************/
  /*! exports provided: howLongAgo, howLongFromNow, isToday, isThisYear */
  /***/function srcTimeFunctionsJs(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "howLongAgo", function () {
      return howLongAgo;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "howLongFromNow", function () {
      return howLongFromNow;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "isToday", function () {
      return isToday;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "isThisYear", function () {
      return isThisYear;
    });

    function howLongAgo(previous) {
      var current = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();

      var msPerSecond = 1000;
      var msPerMinute = 60 * msPerSecond;
      var msPerHour = msPerMinute * 60;
      var msPerDay = msPerHour * 24;
      var msPerMonth = msPerDay * 30;
      var msPerYear = msPerDay * 365;

      var elapsed = current - previous;

      if (elapsed < msPerSecond * 10) {
        return 'just now';
      }

      if (elapsed < msPerMinute) {
        var seconds = Math.round(elapsed / msPerSecond);
        return seconds + ' second' + (seconds > 1 ? 's' : '') + ' ago';
      } else if (elapsed < msPerHour) {
        var minutes = Math.round(elapsed / msPerMinute);
        return minutes + ' minute' + (minutes > 1 ? 's' : '') + ' ago';
      } else if (elapsed < msPerDay) {
        var hours = Math.round(elapsed / msPerHour);
        return hours + ' hour' + (hours > 1 ? 's' : '') + ' ago';
      } else if (elapsed < msPerMonth) {
        var days = Math.round(elapsed / msPerDay);
        return days + ' day' + (days > 1 ? 's' : '') + ' ago';
      } else if (elapsed < msPerYear) {
        var months = Math.round(elapsed / msPerMonth);
        return months + ' month' + (months > 1 ? 's' : '') + ' ago';
      } else {
        var years = Math.round(elapsed / msPerYear);
        return years + ' year' + (years > 1 ? 's' : '') + ' ago';
      }
    }

    function howLongFromNow(then, now) {

      var msPerSecond = 1000;
      var msPerMinute = 60 * msPerSecond;
      var msPerHour = msPerMinute * 60;
      var msPerDay = msPerHour * 24;
      var msPerMonth = msPerDay * 30;
      var msPerYear = msPerDay * 365;

      var remaining = then - now;

      var eventDate = new Date(then);

      if (remaining < msPerSecond * 10) {
        return 'In a moment';
      }

      if (remaining < msPerMinute) {
        var seconds = Math.floor(remaining / msPerSecond);
        return 'In ' + seconds + ' seconds';
      } else if (remaining < msPerHour) {
        var minutes = Math.floor(remaining / msPerMinute);
        var _seconds = Math.floor(remaining / msPerSecond) % 60;

        return 'In ' + minutes + ' minutes and ' + _seconds + ' seconds';
      } else if (remaining < msPerDay) {
        var hours = Math.floor(remaining / msPerHour);
        return 'In ' + hours + ' hours at ' + eventDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });
      } else if (remaining < msPerMonth) {
        var days = Math.floor(remaining / msPerDay);

        if (days > 7) {
          return 'In ' + days + ' days:\n      ' + eventDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) + ' \n      at ' + eventDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });
        } else if (days > 1) {
          return 'On ' + eventDate.toLocaleDateString('en-US', { weekday: 'long' }) + ',\n      ' + eventDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' \n      at ' + eventDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });
        } else {
          return 'Tomorrow at ' + eventDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });
        }
      } else if (remaining < msPerYear) {
        var months = Math.floor(remaining / msPerMonth);
        if (months > 1) {
          return 'In ' + months + ' months: \n        ' + eventDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + ' \n        at ' + eventDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });
        } else {
          return 'Next month: \n      ' + eventDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) + ' \n      at ' + eventDate.toLocaleTimeString({ hour: 'numeric', minute: 'numeric' });
        }
      } else {
        var years = Math.floor(remaining / msPerYear);
        return 'In ' + years + ' years: \n     ' + eventDate.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
      }
    }

    var isToday = function isToday(date, today) {
      return today.getFullYear() === date.getFullYear() && today.getMonth() === date.getMonth() && today.getDate() === date.getDate();
    };

    var isThisYear = function isThisYear(date, today) {
      return today.getFullYear() === date.getFullYear();
    };

    /***/
  }

  /******/ }));
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: generateGetter, generateAction, generateGetters, generateActions, createGTTransitionFactory, createGTStateModule, nextAnonymousQueryId, createGTQueryFactory, createGTQuery, createGTFunctionQuery, createFactoryFromQuery, createGTStore */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateGetter", function() { return generateGetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateAction", function() { return generateAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateGetters", function() { return generateGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateActions", function() { return generateActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGTTransitionFactory", function() { return createGTTransitionFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGTStateModule", function() { return createGTStateModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextAnonymousQueryId", function() { return nextAnonymousQueryId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGTQueryFactory", function() { return createGTQueryFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGTQuery", function() { return createGTQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGTFunctionQuery", function() { return createGTFunctionQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactoryFromQuery", function() { return createFactoryFromQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGTStore", function() { return createGTStore; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "../../node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @blast-engine/utils */ "../utils/dist/utils.js");
/* harmony import */ var _blast_engine_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__);
var _jsxFileName = '/Users/santi/code/example/packages/gt-store/src/index.js';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var generateGetter = function generateGetter(queryFactory, gts) {
  return function (args) {
    return gts.snap(queryFactory(args));
  };
};

var generateAction = function generateAction(transitionFactory, gts) {
  return function (args) {
    return gts.doTransition(transitionFactory(args));
  };
};

var generateGetters = function generateGetters(queryFactories, gts) {
  return Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["objMap"])(queryFactories, function (qf) {
    return generateGetter(qf, gts);
  });
};

var generateActions = function generateActions(transitionFactories, gts) {
  return Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["objMap"])(transitionFactories, function (tf) {
    return generateAction(tf, gts);
  });
};

var createGTTransitionFactory = function createGTTransitionFactory(transitionFn) {
  return function (args) {
    return function (state) {
      return transitionFn({ args: args, state: state });
    };
  };
};

var createGTStateModule = function createGTStateModule(root) {
  var createModularGTQueryFactory = function createModularGTQueryFactory(givenDefinition) {
    var gdef = void 0;
    if (Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isFn"])(givenDefinition)) gdef = { deriveValue: givenDefinition };else gdef = givenDefinition;

    var givenType = gdef.type;
    var modularType = givenType || nextAnonymousQueryId();
    var type = root + '_' + modularType;

    var givenDeriveValue = gdef.deriveValue;
    var modularDeriveValue = function modularDeriveValue(args) {
      var state = args.state;
      var moduleState = state[root] || {};
      return givenDeriveValue(Object.assign({}, args, { state: moduleState }));
    };

    var definition = Object.assign({}, gdef, {
      type: type,
      deriveValue: modularDeriveValue
    });

    return createGTQueryFactory(definition);
  };

  var createModularGTTransitionFactory = function createModularGTTransitionFactory(modularTransitionFn) {
    return function (args) {
      return function (state) {
        var moduleState = state[root] || {};
        var updatedModuleState = modularTransitionFn({ args: args, state: moduleState });
        return Object.assign({}, state, _defineProperty({}, root, updatedModuleState));
      };
    };
  };

  var moduleStateQ = createGTFunctionQuery(function (_ref) {
    var state = _ref.state;
    return state[root] || {};
  });
  var moduleStateF = createFactoryFromQuery(moduleStateQ);

  return {
    query: createModularGTQueryFactory,
    createModularGTQueryFactory: createModularGTQueryFactory,
    transition: createModularGTTransitionFactory,
    createModularGTTransitionFactory: createModularGTTransitionFactory,
    moduleStateQ: moduleStateQ,
    moduleStateF: moduleStateF
  };
};

// @todo: this state should be somewhere else
var anonymousQueryTypeCounter = 0;
var nextAnonymousQueryId = function nextAnonymousQueryId() {
  return 'anonymous_query_type_' + anonymousQueryTypeCounter++;
};

var createGTQueryFactory = function createGTQueryFactory(givenDefinition) {
  var definition = void 0;
  if (Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isFn"])(givenDefinition)) definition.deriveValue = givenDefinition;else definition = Object.assign({}, givenDefinition || {});

  if (!Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isFn"])(definition.argsAreValid)) definition.argsAreValid = function (args) {
    return true;
  };

  if (!Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isFn"])(definition.valuesAreEquivalent)) definition.valuesAreEquivalent = function (value1, value2) {
    return Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["areShallowEquivalent"])(value1, value2);
  };

  if (!Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isFn"])(definition.argsAreEquivalent)) {
    if (Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isBool"])(definition.argsAreEquivalent)) definition.argsAreEquivalent = function () {
      return definition.argsAreEquivalent;
    };else definition.argsAreEquivalent = function (args1, args2) {
      return Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["areShallowEquivalent"])(args1, args2);
    };
  }

  // @todo: this is no longer a pure function because of nextAnonQueryId()
  // nextAnonQueryId function should be passed in
  definition.type = definition.type || nextAnonymousQueryId();

  var dependenciesFn = void 0;
  var givenDependencies = definition.dependencies;
  if (Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isFn"])(givenDependencies)) dependenciesFn = givenDependencies;else if (Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isObj"])(givenDependencies)) dependenciesFn = function dependenciesFn() {
    return givenDependencies;
  };else dependenciesFn = function dependenciesFn() {};
  definition.dependencies = dependenciesFn;

  if (!Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["isFn"])(definition.skipCheckIfDependenciesUnchanged)) {
    var scidc = definition.skipCheckIfDependenciesUnchanged;
    definition.skipCheckIfDependenciesUnchanged = function () {
      return !!scidc;
    };
  }

  return function (givenArgs) {
    var args = Object.assign({}, givenArgs || {});

    var query = Object.assign({
      isGTQuery: true
    }, definition, {
      definition: definition, givenDefinition: givenDefinition,
      args: args, givenArgs: givenArgs
    });

    query.dependencies = function (args) {
      return Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["kv"])(definition.dependencies(args)).map(function (_ref2) {
        var name = _ref2.k,
            query = _ref2.v;
        return { name: name, query: query };
      });
    };

    query.equals = function (other) {
      if (!query.type) return false;
      if (!other.type) return false;
      if (query.type !== other.type) return false;

      return definition.argsAreEquivalent(query.args, other.args);
    };

    if (!definition.argsAreValid(args)) {
      var errMsg = 'invalid args provided to query ' + query.type;
      console.error(errMsg, args);
      throw new Error(errMsg);
    }

    return query;
  };
};

var createGTQuery = function createGTQuery(definition) {
  return createGTQueryFactory(Object.assign({}, definition, {
    type: definition.type || 'anonymous_query'
  }))();
};

var createGTFunctionQuery = function createGTFunctionQuery(deriveValue) {
  return createGTQuery({
    type: 'anonymous_function_query',
    deriveValue: deriveValue
  });
};

var createFactoryFromQuery = function createFactoryFromQuery(query) {
  return function () {
    return query;
  };
};

var GTStore = function GTStore() {
  var _this = this;

  _classCallCheck(this, GTStore);

  this.state = {};
  this.emitter = new _blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["Emitter"]();

  this.update = function (updateMap) {
    var newState = Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["set"])(_this.state, updateMap);
    _this.state = newState;
    _this.emitter.emit(_this.state);
  };

  this.start = function () {
    _this.emitter.subscribe(_this.updateWatchers);
    return _this;
  };

  this.doTransition = function (transition) {
    var updatedState = transition(_this.state);
    _this.update(updatedState);
  };

  this.watcherIdCounter = 0;
  this.watchers = {};
  this.subscriptionIdCounter = 0;
  this.subscriptions = {};

  this.snap = function (query) {
    var watcher = _this.getWatcherForQuery({ query: query });
    var subscription = _this.createSubscription({ watcher: watcher, handler: function handler() {
        return null;
      } });
    _this.updateWatchers();
    var value = watcher.currentValue;
    subscription.kill();
    return value;
  };

  this.updateWatchers = function () {
    var watcherIdsChecked = {};
    var watchersChanged = [];
    var watcherIdsNotChecked = Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["k"])(_this.watchers);

    var _loop = function _loop() {
      var watcherIdsSkippedThisRound = [];
      watcherIdsNotChecked.forEach(function (watcherId) {
        var watcher = _this.watchers[watcherId];

        var depChecks = watcher.activeDependencies.map(function (_ref3) {
          var watcherId = _ref3.watcherId;
          return { watcherId: watcherId, check: watcherIdsChecked[watcherId] };
        });
        var allDepsChecked = depChecks.every(function (depCheck) {
          return !!depCheck.check;
        });

        if (!allDepsChecked) {
          watcherIdsSkippedThisRound.push(watcherId);return;
        }

        if (watcher.activeDependencies.length && watcher.query.skipCheckIfDependenciesUnchanged({ args: watcher.query.args })) {
          var someDepChanged = depChecks.some(function (depCheck) {
            return !!depCheck.check.changed;
          });
          if (!someDepChanged) {
            watcherIdsChecked[watcherId] = { changed: false };return;
          }
        }

        var nextValue = _this.deriveValueForWatcher(watcher);

        var valuesAreEquivalent = watcher.query.valuesAreEquivalent(watcher.currentValue, nextValue);

        if (!valuesAreEquivalent) {
          watcher.currentValue = nextValue;
          watcherIdsChecked[watcherId] = { changed: true };
          watchersChanged.push(watcher);
        } else {
          watcherIdsChecked[watcherId] = { changed: false };
        }
      });
      watcherIdsNotChecked = watcherIdsSkippedThisRound;
    };

    while (watcherIdsNotChecked.length) {
      _loop();
    }

    watchersChanged.forEach(function (watcher) {
      Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["v"])(watcher.subscriptions).forEach(function (s) {
        return s.handler(watcher.currentValue);
      });
    });
  };

  this.findExistingWatcherForQuery = function (_ref4) {
    var query = _ref4.query;

    var existingWatcher = Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["v"])(_this.watchers).find(function (watcher) {
      return watcher.query.equals(query);
    });
    return existingWatcher || null;
  };

  this.deriveValueForWatcher = function (watcher) {

    var dependencyCurrentValues = Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["rollup"])({
      array: watcher.activeDependencies,
      deriveValue: function deriveValue(ad) {
        return ad.watcher.currentValue;
      },
      deriveKey: function deriveKey(ad) {
        return ad.dependency.name;
      }
    });

    var value = watcher.query.deriveValue({
      state: _this.state,
      args: watcher.query.args,
      deps: dependencyCurrentValues
    });

    return value;
  };

  this.createWatcherForQuery = function (_ref5) {
    var query = _ref5.query;

    var id = 'watcher_' + _this.watcherIdCounter++;

    var activeDependencies = query.dependencies(query.args).map(function (dependency) {
      var watcher = _this.getWatcherForQuery({
        query: dependency.query
      });
      return { watcher: watcher, watcherId: watcher.id, dependency: dependency };
    });

    var watcher = {
      id: id,
      query: query,
      activeDependencies: activeDependencies,
      subscriptions: {},
      dependents: {}
    };

    activeDependencies.forEach(function (ad) {
      ad.watcher.dependents[id] = watcher;
    });

    var initialValue = _this.deriveValueForWatcher(watcher);
    watcher.currentValue = initialValue;

    _this.watchers[id] = watcher;
    return watcher;
  };

  this.getWatcherForQuery = function (_ref6) {
    var query = _ref6.query;

    var existingWatcher = _this.findExistingWatcherForQuery({ query: query });
    if (existingWatcher) return existingWatcher;else return _this.createWatcherForQuery({ query: query });
  };

  this.removeWatcherIfNotNeeded = function (watcherId) {
    var watcher = _this.watchers[watcherId];
    if (!watcher) return 'not found';
    if (Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["k"])(watcher.subscriptions).length) return false;
    if (Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["k"])(watcher.dependents).length) return false;
    watcher.dead = true;
    watcher.activeDependencies.forEach(function (dependency) {
      delete dependency.watcher.dependents[watcherId];
      _this.removeWatcherIfNotNeeded(dependency.watcher.id);
    });
    delete _this.watchers[watcherId];
  };

  this.killSubscription = function (subscriptionId) {
    var subscription = _this.subscriptions[subscriptionId];
    if (!subscription) return 'not found';
    subscription.dead = true;
    delete subscription.watcher.subscriptions[subscriptionId];
    delete _this.subscriptions[subscriptionId];
    _this.removeWatcherIfNotNeeded(subscription.watcher.id);
  };

  this.createSubscription = function (_ref7) {
    var watcher = _ref7.watcher,
        handler = _ref7.handler,
        about = _ref7.about;

    var id = 'subscription_' + _this.subscriptionIdCounter++;

    var subscription = {
      id: id,
      watcher: watcher,
      handler: handler,
      about: about,
      kill: function kill() {
        return _this.killSubscription(id);
      }
    };

    _this.subscriptions[id] = subscription;
    watcher.subscriptions[id] = subscription;
    return subscription;
  };

  this.subscribe = function (_ref8) {
    var query = _ref8.query,
        handler = _ref8.handler;

    var givenQuery = query;
    if (givenQuery.isGTQuery) query = givenQuery;else if (typeof givenQuery === 'function') query = createGTFunctionQuery(givenQuery);else query = createGTQuery(givenQuery);

    var watcher = _this.getWatcherForQuery({ query: query });
    var subscription = _this.createSubscription({ watcher: watcher, handler: handler });
    return { subscription: subscription, initialValue: watcher.currentValue };
  };

  this.connect = function (deriveQueriesFromProps) {
    return function (Component) {
      var store = _this;
      return function (_React$PureComponent) {
        _inherits(GTConnectedComponent, _React$PureComponent);

        function GTConnectedComponent() {
          var _ref9;

          var _temp, _this2, _ret2;

          _classCallCheck(this, GTConnectedComponent);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret2 = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref9 = GTConnectedComponent.__proto__ || Object.getPrototypeOf(GTConnectedComponent)).call.apply(_ref9, [this].concat(args))), _this2), _this2.state = {
            currentValues: {},
            queries: {},
            subscriptions: {}
          }, _this2.waitingUpdatedState = null, _this2.waitingUpdateTimeout = null, _this2.createSubscriptionHandler = function (name) {
            return function (updatedValue) {
              var state = _this2.waitingUpdatedState || _this2.state;
              _this2.waitingUpdatedState = Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["set"])(state, _defineProperty({}, 'currentValues.' + name, updatedValue));

              if (_this2.waitingUpdateTimeout) return;
              _this2.waitingUpdateTimeout = setTimeout(function () {
                _this2.waitingUpdateTimeout = null;
                var updatedState = _this2.waitingUpdatedState;
                _this2.waitingUpdatedState = null;
                _this2.setState(updatedState);
              });
            };
          }, _temp), _possibleConstructorReturn(_this2, _ret2);
        }

        _createClass(GTConnectedComponent, [{
          key: 'updateSubscriptions',
          value: function updateSubscriptions() {
            var _this3 = this;

            var queries = deriveQueriesFromProps(this.props);

            var changedQueries = Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["kv"])(queries, { k: 'name', v: 'query' }).filter(function (_ref10) {
              var name = _ref10.name,
                  query = _ref10.query;

              var currentQuery = _this3.state.queries[name];
              if (!currentQuery) return true;
              return !currentQuery.equals(query);
            });

            if (!changedQueries.length) return;
            console.log(changedQueries);
            var updatedState = changedQueries.reduce(function (updatedState, _ref11) {
              var _set2;

              var name = _ref11.name,
                  query = _ref11.query;

              var existingSubscription = _this3.state.subscriptions[name];
              if (existingSubscription) existingSubscription.kill();
              var handler = _this3.createSubscriptionHandler(name);

              var _store$subscribe = store.subscribe({ query: query, handler: handler }),
                  subscription = _store$subscribe.subscription,
                  initialValue = _store$subscribe.initialValue;

              return Object(_blast_engine_utils__WEBPACK_IMPORTED_MODULE_1__["set"])(updatedState, (_set2 = {}, _defineProperty(_set2, 'queries.' + name, query), _defineProperty(_set2, 'subscriptions.' + name, subscription), _defineProperty(_set2, 'currentValues.' + name, initialValue), _set2));
            }, this.state);

            this.setState(updatedState);
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            this.updateSubscriptions();
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            this.updateSubscriptions();
          }
        }, {
          key: 'render',
          value: function render() {
            var currentValues = this.state.currentValues;

            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, Object.assign({}, this.props, currentValues, _defineProperty({ gt: currentValues, __source: {
                fileName: _jsxFileName,
                lineNumber: 400
              },
              __self: this
            }, '__self', this)));
          }
        }]);

        return GTConnectedComponent;
      }(react__WEBPACK_IMPORTED_MODULE_0___default.a.PureComponent);
    };
  };
};

var createGTStore = function createGTStore() {
  return new GTStore();
};

/***/ })

/******/ })));
//# sourceMappingURL=gt-store.js.map